<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
          <h3>
            Modificar Ajustes:
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <div class="row">
            <div class="col-6">
              <CInput label="Nombre Compañia" type="text" placeholder="Ej: Blue Star" v-model="settings.company"></CInput>
              <CInput label="Dirección" type="text" placeholder="Ej: 27 de Febrero" v-model="settings.address"></CInput>
              <CInput label="RNC" type="text" placeholder="Ej: " v-model="settings.rnc"></CInput>
            </div>
            <div class="col-6">
                <CInputFile
                    type="file"
                    v-on:change="handleFileUpload"
                    placeholder="New file"
                />
            </div>
          </div>
          
          <CButton color="primary" @click="saveData()">
            Actualizar
          </CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";

export default {
  name: 'FormSettings',
  mixins: [formMixin],
  data() {
    return {
        settings: {
          company: '',
          address: '',
          rnc: '',
          logo_id: ''
        },
        logo_url: '',
        statuses: [
          {
            label: "Activo",
            value: "1"
          },
          {
            label: "Inactivo",
            value: "0"
          }
        ],

    }
  },
  mounted() {
      this.getSettings();
  },
  methods: {
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    saveData() {
        // const data = formData || this.prepareObjectData();
        const data = this.settings;
        this.$emit("saved", data);
        console.log(data);
        let url = '/api/settings?token='+ localStorage.getItem("api_token");
        let sendRequest = null;

        sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        this.message = 'Successfully updated settings.';
                        this.showAlert();
                    }
                    console.log(response);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert();
                    } else{
                        console.log(error);
                        this.$router.push({ path: '/login' }); 
                    }
                }
            };
        sendRequest();
        return data;
    },
    handleFileUpload(files, event){
        // let self = this;
        let formData = new FormData();
        formData.append('file', files[0]);
        // TODO: temporary, change this
        const folderId = 7;
        axios.post('/api/media/file/store?thisFolder=' + folderId + '&token=' + localStorage.getItem("api_token"),
            formData,
            { headers: {
                'Content-Type': 'multipart/form-data'
            }}
        ).then(response => {
            this.getFoldersAndFiles(folderId)
        })
        .catch(error => {
            console.log(error)
            this.$router.push({ path: '/login' })
        });
    },
    getFoldersAndFiles(folderId){
        let self = this;
        axios.get(  '/api/media?id=' + folderId + '&token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            // self.medias         = response.data.medias
            // self.mediaFolders   = response.data.mediaFolders
            // self.thisFolder     = response.data.thisFolder
            // self.parentFolder   = response.data.parentFolder
            // self.buildItems()
            // self.rightCard = 'fileInfo'
            console.log(data);
            if (data) {
              data.forEach(elem => {
                this.logo_url = elem.url;
              });
            }
        }).catch(function (error) {
            console.log(error)
            this.$router.push({ path: '/login' })
        });
    },
    buildItems(){
        this.items = [];
        for(var i=0; i<this.medias.length; i++){
            this.items.push({
                type: 'file',
                name: this.medias[i].name,
                id: this.medias[i].id,
                url: this.medias[i].url,
                mime: this.medias[i].mime_type
            })
        }
    },
    getSettings() {
        axios.get('/api/settings?token='+ localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            this.settings = data;
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    }
  }
}

/*
      items: (id) => {
        const user = usersData.find( user => user.id.toString() === id)
        const userDetails = user ? Object.entries(user) : [['id', 'Not found']]
        return userDetails.map(([key, value]) => {return {key: key, value: value}})
      },
*/

</script>
